import { useEffect } from "react";
import CalendarYearSelect from "./Calendar/CalendarYearSelect";
import CalendarMonthSelect from "./Calendar/CalendarMonthSelect";

const DatePicker = ({ dateValues, setDateValues }) => {
  const getDateMonth = () => {
    var date = new Date();
    return date.getMonth() + 1;
  };
  const getDateYear = () => {
    var date = new Date();
    return date.getFullYear();
  };

  const handleDateChange = (year = getDateYear(), month = getDateMonth()) => {
    setDateValues({
      year: year,
      month: month,
    });
  };
  useEffect(() => {
    const nowDate = new Date();
    setDateValues({
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
    });
  }, []);
  return (
    <div className="d-flex flex-wrap justify-content-evenly date-picker">
      <CalendarYearSelect
        dateValues={dateValues}
        changeCalendarDate={handleDateChange}
      />
      <CalendarMonthSelect
        dateValues={dateValues}
        changeCalendarDate={handleDateChange}
        allYear={true}
      />
    </div>
  );
};

export default DatePicker;
